import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useMemo } from 'react';
import { MatchContentWithProvider } from './MatchContent';

const _labelSize = 'tiny'

export const MatchesDate = ({
  dateKey,
  levelKey,
  sectionKey,
  matchDisplayType,
  matchScheduleDisplayType,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {};
  const {
    scheduleLevelKeys: _scheduleLevelKeys,
    levelSectionDateMatches: _levelSectionDateMatches
  } = matches_groupInfo ?? {};

  const lsdms = _levelSectionDateMatches?.[levelKey]?.[dateKey]?.[sectionKey]

  const dateMatches = useMemo(() => {
    if (!lsdms) return <div>No Matches</div>;
    return _.map(lsdms, (match) => (
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  }, [JSON.stringify(lsdms)])

  return dateMatches

}

